import CryptoJs from 'crypto-js';
import CONFIG_KEY from './config_key';

export const decode = (ciphertxt) => {
    const bytes = CryptoJs.AES.decrypt(ciphertxt, CONFIG_KEY)
    // console.log(bytes.toString(CryptoJs.enc.Utf8), ciphertxt, CONFIG_KEY)
    return bytes.toString(CryptoJs.enc.Utf8);
};